import { render, staticRenderFns } from "./UserSelection.vue?vue&type=template&id=39f8ee12&scoped=true&"
import script from "./UserSelection.vue?vue&type=script&lang=js&"
export * from "./UserSelection.vue?vue&type=script&lang=js&"
import style0 from "./UserSelection.vue?vue&type=style&index=0&id=39f8ee12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f8ee12",
  null
  
)

export default component.exports